import React from "react";
import PropTypes from "prop-types";
import useCustomStyles from "./customStyles.js"; // Adjust path if needed

const SeverityCell = ({ value }) => {
  const classes = useCustomStyles();
  const customSeverity = `custom${
    value.charAt(0).toUpperCase() + value.slice(1)
  }`; // Example: "customWarning"

  return (
    <div className={classes.severityBlock}>
      <span
        className={`${classes.severityIndicator} 
        ${classes[customSeverity] || ""}`}
      />
      <span>{value}</span>
    </div>
  );
};

SeverityCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SeverityCell;
